import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "childOnActive", "isActive", "pulser", "readyToStart", "scrollTo", "scrollToTarget", "target", "targetRef", "open", "onOpenStart", "onCloseStart"];
let _ = t => t,
  _t,
  _t2;
import { useEffect, useRef, cloneElement } from 'react';
import { createGlobalStyle } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Prevents Floating UI focus guards from affecting table header layout.
 *
 * Floating UI inserts focus guards (`data-floating-ui-focus-guard`) to manage
 * keyboard focus for accessibility. However, their default <span> can disrupt
 * the table layout if rendered alongside <th> content.
 *
 * Using `display: contents` keeps the guards in the DOM for accessibility
 * purposes without affecting layout or appearance.
 */
const FOCUS_GUARD_FIX_TAGS = ['TH'];
const UITourPopoverGlobalStyle = createGlobalStyle(_t || (_t = _`
  table th + [data-floating-ui-focus-guard] {
    display: contents;
  }
`));
const UITourPulserGlobalStyle = createGlobalStyle(_t2 || (_t2 = _`
  html,
  body {
    overflow: hidden;
  }
`));
const TourStepChildren = _ref => {
  let {
      children,
      childOnActive,
      isActive,
      pulser,
      readyToStart,
      scrollTo,
      scrollToTarget,
      target,
      targetRef,
      open,
      onOpenStart,
      onCloseStart
    } = _ref,
    receivedProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const showScrollToTarget = scrollTo && !target && !scrollToTarget;
  const showChildOnActive = readyToStart && childOnActive;
  const previousOpen = useRef(open);

  // Using isActive instead of readyToStart here because global style needs to be appended before `beforeStart` hook and `scrollToTarget`
  const shouldPreventOverflow = isActive && typeof pulser === 'object' && pulser.preventOverflow === true;
  useEffect(() => {
    if (open !== previousOpen.current) {
      if (open) {
        onOpenStart === null || onOpenStart === void 0 || onOpenStart();
      } else {
        onCloseStart === null || onCloseStart === void 0 || onCloseStart();
      }
      previousOpen.current = open;
    }
  }, [open, onCloseStart, onOpenStart]);

  // solves an edge case where children is an array of elements (integrations-lib + IntegrationsUISpaceSword)
  const [firstChild, ...restChildren] = children && Array.isArray(children) ? children : [children];
  const clonedChild = firstChild ? /*#__PURE__*/cloneElement(firstChild, receivedProps) : null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [clonedChild, restChildren, showScrollToTarget && /*#__PURE__*/_jsx("span", {
      ref: targetRef
    }), showChildOnActive && childOnActive, isActive && FOCUS_GUARD_FIX_TAGS.includes(target === null || target === void 0 ? void 0 : target.tagName) && /*#__PURE__*/_jsx(UITourPopoverGlobalStyle, {}), shouldPreventOverflow && /*#__PURE__*/_jsx(UITourPulserGlobalStyle, {})]
  });
};
export default TourStepChildren;